export const MIN_LOOKUP_LIMIT = 100;
export const MAX_LOOKUP_LIMIT = 30000;
export const DBS = {
  "NCBI ClinVar2": "Clinvar",
  "Sanger Cosmic Licensed": "Cosmic",
  "Saphetor VarSome AI Variant": "Varsome AI",
  "UNIPROT UniProt Variants": "UniProt",
  "WUSTL DoCM": "DoCM",
  "CTTI AACT": "AACT",
  "GenCC GenCC": "GenCC",
  "Genomics England PanelApp": "PanelApp",
  "JHU OMIM": "OMIM",
  "NHGRI CGD": "CGD",
  "Saphetor VarSome AI": "Varsome AI",
  "WUSTL DGI": "DGI",
  "dbNSFP dbNSFP genes": "dbNSFP",
  "Weill Cornell Medicine PMKB": "PMKB",
  "Cancer Gene Census": "CGC",
  "Saphetor KnownPathogenic": null,
  "Saphetor PubMedUserEntry": "User Linked Articles",
};
